import React from "react";

import { GetOverviewMetricsPeriod } from "@covertree/agent-portal-graphql";
import { CalendarToday } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";

interface Props {
  period: GetOverviewMetricsPeriod;
  onPeriodChange(period: GetOverviewMetricsPeriod): void;
}

const mapMetricsPeriodToName = (period: GetOverviewMetricsPeriod): string => {
  switch (period) {
    case GetOverviewMetricsPeriod.Today:
      return "Today";
    case GetOverviewMetricsPeriod.Week:
      return "This week";
    case GetOverviewMetricsPeriod.Month:
      return "This month";
    case GetOverviewMetricsPeriod.All:
      return "All";
    case GetOverviewMetricsPeriod.Year:
    default:
      return "This year";
  }
};

export function MetricsFilter({ period, onPeriodChange }: Props) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpenMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onMenuitemClick = (itemPeriod: GetOverviewMetricsPeriod) => {
    handleClose();
    onPeriodChange(itemPeriod);
  };

  return (
    <Box display="flex" alignItems="center">
      <Typography mr={1} variant="body2">
        {mapMetricsPeriodToName(period)}
      </Typography>
      <IconButton
        sx={{
          borderColor: "action.disabled",
          borderWidth: 1,
          borderStyle: "solid",
          fontSize: "1.25rem",
          padding: 1.125,
        }}
        onClick={handleOpenMenuClick}>
        <CalendarToday fontSize="inherit" />
      </IconButton>
      <Menu
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        {[
          GetOverviewMetricsPeriod.Today,
          GetOverviewMetricsPeriod.Week,
          GetOverviewMetricsPeriod.Month,
          GetOverviewMetricsPeriod.Year,
          GetOverviewMetricsPeriod.All,
        ].map((itemPeriod) => (
          <MenuItem
            key={itemPeriod}
            onClick={() => onMenuitemClick(itemPeriod)}>
            {mapMetricsPeriodToName(itemPeriod)}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
